import { useInstitution } from '#core/Institution';
import PageQuery from '#core/PageQuery';
import {
  getWurRankingData,
  wurRankingDataQuery,
} from '#coreComponents/ProductTopbar/wurRankingQuery';
import Topbar from '#coreComponents/Topbar';
import { GetRankDataQuery } from '#types/generated/graphql';
import { formatBandedValue } from '#utils/formatUtils';
import { useQuery } from '@apollo/client';
import { Flex } from '@chakra-ui/react';
import React from 'react';
import ImpactProvider, {
  useImpact,
} from '../../../sdgImpact/components/Provider';
import { useLatestImpactRanking } from '../../../sdgImpact/hooks/useLatestImpactRanking';
import { DataPlusEmbargoProvider } from '../../Embargo/components/DataPlusEmbargoProvider';
import { useDataplusEmbargoData } from '../../Embargo/contexts/DataplusEmbargoContext';
import SettingsButton from './SettingsButton';

const DashboardTopbar = () => {
  const {
    institution: { name: institutionName, institutionId },
  } = useInstitution();

  const { availableSelectedYear } = useDataplusEmbargoData();

  const { availableImpactYears } = useImpact();

  const wurQueryResult = useQuery<GetRankDataQuery>(getWurRankingData, {
    ...wurRankingDataQuery(availableSelectedYear, institutionId || ''),
    skip: !institutionId,
  });

  const wurBanding = wurQueryResult.data?.release?.level1?.result?.rank;

  const { year: impactYear, rank: impactBanding } = useLatestImpactRanking(
    institutionId || '',
    availableImpactYears,
  );

  return (
    <Topbar
      fitSidebar
      withLogo
      title={institutionName}
      wurRank={wurBanding && formatBandedValue(wurBanding)}
      wurYear={availableSelectedYear}
      impactRank={impactBanding && formatBandedValue(impactBanding)}
      impactYear={impactYear}
    >
      <Flex justifyContent="flex-end" gridGap={6} px={4}>
        <SettingsButton />
      </Flex>
    </Topbar>
  );
};

const DashboardEmbargoTopBar = () => (
  <PageQuery>
    <DataPlusEmbargoProvider
      viewEmbargoAction="dataplus:viewPage:overview-embargo"
      viewFreeEmbargoAction="dataplus:viewPage:overview-free-embargo"
      isDetailsPage={false}
    >
      <ImpactProvider>
        <DashboardTopbar />
      </ImpactProvider>
    </DataPlusEmbargoProvider>
  </PageQuery>
);

export default DashboardEmbargoTopBar;
